import { useState } from 'react';
import { TableInput } from '../../../../components/common';

interface Ifoot {
  moduleData: any;
  isView: any;
}
const TFoot = ({ moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);
  return (
    <tfoot>
      <tr>
        <th align="left" colSpan={12}>
          Details of Work Done :-
          <TableInput
            isView={isView}
            name="work_done"
            type="text"
            value={moduleData.work_done}
            onChange={(e) => {
              moduleData.work_done = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={3} align="left">
          Complained By (Dept):
          <TableInput
            isView={isView}
            name="complaint_by_dept"
            type="text"
            value={moduleData.complaint_by_dept}
            onChange={(e) => {
              moduleData.complaint_by_dept = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={3} align="left">
          Received By (Maint/TRD):
          <TableInput
            isView={isView}
            name="received_by_maint"
            type="text"
            value={moduleData.received_by_maint}
            onChange={(e) => {
              moduleData.received_by_maint = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={3} align="left">
          Veryfy By(Quality):
          <TableInput
            isView={isView}
            name="verified_by_quality"
            type="text"
            value={moduleData.verified_by_quality}
            onChange={(e) => {
              moduleData.verified_by_quality = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={3} align="left">
          Total Break Down Time(Hrs):
          <TableInput
            isView={isView}
            name="total_breakdown_time"
            type="text"
            value={moduleData.total_breakdown_time}
            onChange={(e) => {
              moduleData.total_breakdown_time = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
